var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMasterCardLogo = function SvgMasterCardLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 862.8 533.3"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".MasterCardLogo_svg__cls-1{fill:#f79e1b}"))), /*#__PURE__*/React.createElement("g", {
    id: "MasterCardLogo_svg__svg895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "MasterCardLogo_svg__rect887",
    d: "M303.1 57h256.7v419.3H303.1z",
    style: {
      fill: "#ff5f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "MasterCardLogo_svg__path889",
    d: "M329.5 266.7c0-81.8 37.5-159.1 101.8-209.6C315.6-33.9 148-13.8 57 102s-70.9 283.4 44.9 374.4c96.7 76 232.8 76 329.5 0-64.4-50.5-101.9-127.8-101.8-209.7Z",
    style: {
      fill: "#eb001b"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "MasterCardLogo_svg__path891",
    d: "M837.3 431.9v-8.6h3.7v-1.8h-8.8v1.8h3.5v8.6zm17.1 0v-10.4h-2.7l-3.1 7.4-3.1-7.4h-2.7v10.4h1.9v-7.8l2.9 6.7h2l2.9-6.7v7.8z",
    className: "MasterCardLogo_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "MasterCardLogo_svg__path893",
    d: "M862.8 266.7c0 147.2-119.4 266.6-266.6 266.6-59.8 0-117.8-20.1-164.8-57 115.8-91 135.9-258.6 44.9-374.4-13.1-16.7-28.2-31.8-44.9-44.9 115.8-91 283.4-70.9 374.4 44.8 36.9 47 57 105 57 164.8Z",
    className: "MasterCardLogo_svg__cls-1"
  }))));
};
export default SvgMasterCardLogo;